import React, { useState } from 'react';
import axios from 'axios';
import { Lock, User, Eye, EyeOff, X } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://sledovanie-aut-api.onrender.com';

const AdminLogin = ({ onLogin, onClose }) => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        username,
        password
      });

      if (response.data.access_token) {
        // Uložiť token do localStorage
        localStorage.setItem('admin_token', response.data.access_token);
        localStorage.setItem('token_expires', Date.now() + (response.data.expires_in * 1000));
        
        // Nastaviť default authorization header pre axios
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
        
        onLogin();
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        setError('Nesprávne prihlasovacie údaje');
      } else if (error.response?.status === 429) {
        setError('Príliš veľa pokusov. Skúste znova neskôr.');
      } else {
        setError('Chyba pri prihlasovaní. Skúste znova.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header justify-center" style={{position: 'relative', paddingRight: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
          <div style={{width: '100%'}}>
            <div className="flex items-center gap-2 justify-center" style={{width: '100%'}}>
              <Lock size={26} className="text-primary flex-shrink-0" />
              <span className="modal-title" style={{marginBottom: 0}}>Admin Prístup</span>
            </div>
            <div className="text-sm text-gray-500 mt-1" style={{width: '100%'}}>Zadajte admin prihlasovacie údaje</div>
          </div>
          <button
            onClick={onClose}
            className="btn btn-secondary btn-sm"
            style={{position: 'absolute', top: 16, right: 16, zIndex: 2, background: 'white', border: 'none', boxShadow: 'none'}}
            aria-label="Zavrieť"
          >
            <X size={18} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body space-y-4">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                Používateľské meno
              </label>
              <div className="flex items-center gap-2">
                <User size={18} className="text-gray-400 flex-shrink-0" />
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  disabled={isLoading}
                  required
                  className="form-input"
                  style={{flex: 1, minWidth: 0}}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Heslo
              </label>
              <div className="flex items-center gap-2">
                <Lock size={18} className="text-gray-400 flex-shrink-0" />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Zadajte heslo"
                  className={`form-input ${error ? 'error' : ''}`}
                  disabled={isLoading}
                  autoFocus
                  required
                  style={{flex: 1, minWidth: 0}}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-gray-400 hover:text-gray-600 ml-1"
                  tabIndex={-1}
                  style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
                <X size={16} className="text-red-600" />
                <span className="text-red-700 text-sm">{error}</span>
              </div>
            )}
          </div>
          
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              Zrušiť
            </button>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={isLoading}
            >
              {isLoading ? 'Prihlasovanie...' : 'Prihlásiť sa'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;